/**
 * Cart Add-on Product (Rakhi) — Mittai Shop
 * Handles the one-click "ADD" button on the cart add-on strip.
 * Delegated on document so it survives cart page + cart drawer AJAX re-renders.
 */

(function () {
  'use strict';

  function sectionsForPage() {
    var sections = [];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');

    if (items) sections.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    if (footer) sections.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    sections.push({ id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' });

    return sections;
  }

  function sectionInnerHTML(html, selector) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var el = parsed.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function renderPageSections(response, sections) {
    sections.forEach(function (section) {
      var target = document.getElementById(section.id);
      if (!target || !response.sections || !response.sections[section.section]) return;

      var destination = section.selector === '.shopify-section' ? target : target.querySelector(section.selector);
      var html = sectionInnerHTML(response.sections[section.section], section.selector);
      if (destination && html !== null) destination.innerHTML = html;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-addon-add]');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var wrapper = btn.closest('[data-cart-addon]');
    var isDrawer = wrapper && wrapper.dataset.cartAddonContext === 'drawer';
    var originalText = btn.textContent;

    btn.disabled = true;
    btn.textContent = 'Adding...';

    var pageSections = isDrawer ? [] : sectionsForPage();
    var sectionIds = isDrawer
      ? ['cart-drawer', 'cart-icon-bubble']
      : pageSections.map(function (section) {
          return section.section;
        });

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          // Add failed (e.g. sold out) — restore the button and surface the reason.
          btn.disabled = false;
          btn.textContent = originalText;
          console.warn('Cart add-on error:', response.description || response.message);
          return;
        }

        if (isDrawer) {
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(response);
          } else {
            window.location.reload();
          }
          return;
        }

        renderPageSections(response, pageSections);
      })
      .catch(function (error) {
        console.error('Cart add-on failed:', error);
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });
})();
